var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapHoriz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14 11.8601L3.36 14.6501C3.17 14.8501 3.17 15.1601 3.36 15.3601L6.14 18.1501C6.45 18.4701 6.99 18.2401 6.99 17.8001V16.0001H13C13.55 16.0001 14 15.5501 14 15.0001C14 14.4501 13.55 14.0001 13 14.0001H6.99V12.2101C6.99 11.7601 6.45 11.5401 6.14 11.8601ZM20.65 8.65009L17.87 5.86009C17.56 5.54009 17.02 5.77009 17.02 6.21009V8.00009H11C10.45 8.00009 10 8.45009 10 9.00009C10 9.55009 10.45 10.0001 11 10.0001H17.01V11.7901C17.01 12.2401 17.55 12.4601 17.86 12.1401L20.64 9.35009C20.84 9.16009 20.84 8.84009 20.65 8.65009Z",
    fill: "#3D1CAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_1509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapHoriz);
export default __webpack_public_path__ + "static/media/SwapHoriz.e57d1cfa9ec0e8db42b716a32146285a.svg";
export { ForwardRef as ReactComponent };